import api from '../../../api/parametres/_parametres'

const state = () => ({
    /**
     * =============================
     *      PARAM EXCLUSION
     * =============================
     */
    param_exclu_consultation: [],
    param_exclu_analyse: [],
    param_exclu_examen: [],
    param_exclu_medicament: [],
    param_exclu_consommable: [],
    param_exclu_acte: [],
    param_exclu_admission: [],
    param_exclu_chambre: [],
    param_exclu_observation: [],
    param_exclu_bilan_sante: [],
    param_exclu_chirurgie: [],

    // ===== END PARAM EXCLUSION   ======

    patient_est_assure: 0,
    info_assurance: [],
    prix_prestation_assur: 0,

    compagnie_assurances: [],
    assureur: [],
    souscripteurs: [],
    params_prestations: [],
    params_prestation_non_exclus: [],
    params_prestation_all: [],
    souscripteur_detail: [],
    params_analyses: [],

    params_cat_medicaments_all: [],
    params_cat_medicament_exclus: [],

    groupe_assurs: [],
    groupe_assur: '',

    assurance_sans_groupe: [],

    list_consultations: [],
    l_medicaments: [],
    l_categorie_medicaments: [],

    // Exclusions
    list_exclu_consultations: [],
    list_exclu_analyses: [],
    list_exclu_examens: [],
    list_exclu_medicaments: [],
    list_exclu_consommables: [],
    list_exclu_actes: [],
    list_exclu_admissions: [],
    list_exclu_chambres: [],
    list_exclu_observations: [],
    list_exclu_bilan_santes: [],
    list_exclu_chirurgies: [],
    usersExamens: [],

    // CONFIG CLINIQUE
    config_info_clinique: [],
    divers_info: [],
    sfe_configs: [],
    info_currency: [],
    bon_consommables: [],
    liste_all_bon_consommables: [],
    liste_chirurgies: [],

    // Bilan sante 
    liste_bilan_sante: [],

    consumables_of_consultation: [],

    // PARAMETRE ADMISSION
    liste_chambres: [],
    liste_observations: [],
    liste_adimissions: [],
    can_add_differential_computing: '',

    countdown_info: {},
    can_print_param_examen: false,
})

// getters
const getters = {
    // =========  PARAM EXCLU  ==========
    param_exclu_consultation: (state) => {
        return state.param_exclu_consultation
    },

    param_exclu_analyse: (state) => {
        return state.param_exclu_analyse
    },

    param_exclu_examen: (state) => {
        return state.param_exclu_examen
    },

    param_exclu_medicament: (state) => {
        return state.param_exclu_medicament
    },

    param_exclu_consommable: (state) => {
        return state.param_exclu_consommable
    },

    param_exclu_acte: (state) => {
        return state.param_exclu_acte
    },

    param_exclu_admission: (state) => {
        return state.param_exclu_admission
    },

    param_exclu_chambre: (state) => {
        return state.param_exclu_chambre
    },

    param_exclu_observation: (state) => {
        return state.param_exclu_observation
    },

    param_exclu_bilan_sante: (state) => {
        return state.param_exclu_bilan_sante
    },

    param_exclu_chirurgie: (state) => {
        return state.param_exclu_chirurgie
    },
    // ====================================

    patient_est_assure: (state) => {
        return state.patient_est_assure;
    },

    info_assurance: (state) => {
        return state.info_assurance;
    },

    prix_prestation_assur: (state) => {
        return state.prix_prestation_assur;
    },

    l_categorie_medicaments: (state) => {
        return state.l_categorie_medicaments
    },

    l_medicaments: (state) => {
        return state.l_medicaments
    },

    list_consultations: (state) => {
        return state.list_consultations
    },

    compagnie_assurances: (state) => {
        return state.compagnie_assurances
    },

    assureur: (state) => {
        return state.assureur
    },

    // Liste des souscripteur appartenant à une assurance
    souscripteurs: (state) => {
        return state.souscripteurs
    },

    souscripteur_detail: (state) => {
        return state.souscripteur_detail
    },

    /**
     * Prestations exclus
     * @param {*} state 
     * @returns 
     */
    params_prestations: (state) => {
        return state.params_prestations
    },

    /**
     * Prestations non exclus
     * @param {*} state 
     * @returns 
     */
    params_prestation_non_exclus: (state) => {
        return state.params_prestation_non_exclus
    },

    /**
     * Toutes les Prestations 
     * @param {*} state 
     * @returns 
     */
    params_prestation_all: (state) => {
        return state.params_prestation_all
    },

    /**
     * Toutes les categories de medicaments 
     * @param {*} state 
     * @returns 
     */
    params_cat_medicaments_all: (state) => {
        return state.params_cat_medicaments_all
    },

    /**
     * Categories de medicaments exclus
     * @param {*} state 
     * @returns 
     */
    params_cat_medicament_exclus: (state) => {
        return state.params_cat_medicament_exclus
    },

    params_analyses: (state) => {
        return state.params_analyses
    },

    /**
     * Ajouter un groupe d'assurace
     * @param {*} state 
     * @returns 
     */
    groupe_assurs: (state) => {
        return state.groupe_assurs
    },

    groupe_assur: (state) => {
        return state.groupe_assur
    },

    assurance_sans_groupe: (state) => {
        return state.assurance_sans_groupe
    },

    list_exclu_consultations: (state) => {
        return state.list_exclu_consultations
    },

    list_exclu_analyses: (state) => {
        return state.list_exclu_analyses
    },

    list_exclu_examens: (state) => {
        return state.list_exclu_examens
    },

    list_exclu_medicaments: (state) => {
        return state.list_exclu_medicaments
    },

    list_exclu_consommables: (state) => {
        return state.list_exclu_consommables
    },

    list_exclu_actes: (state) => {
        return state.list_exclu_actes
    },

    list_exclu_admissions: (state) => {
        return state.list_exclu_admissions
    },

    list_exclu_chambres: (state) => {
        return state.list_exclu_chambres
    },

    list_exclu_observations: (state) => {
        return state.list_exclu_observations
    },

    list_exclu_bilan_santes: (state) => {
        return state.list_exclu_bilan_santes
    },

    list_exclu_chirurgies: (state) => {
        return state.list_exclu_chirurgies
    },

    usersExamens: (state) => {
        return state.usersExamens
    },

    config_info_clinique: (state) => {
        return state.config_info_clinique
    },

    divers_info: (state) => {
        return state.divers_info
    },

    info_currency: (state) => {
        return state.info_currency
    },

    bon_consommables: (state) => {
        return state.bon_consommables
    },

    liste_all_bon_consommables: (state) => {
        return state.liste_all_bon_consommables
    },

    liste_chirurgies: (state) => {
        return state.liste_chirurgies
    },
     
    liste_bilan_sante: (state) => {
        return state.liste_bilan_sante
    },

    consumables_of_consultation: (state) => {
        return state.consumables_of_consultation
    },

    liste_chambres: (state) => {
        return state.liste_chambres
    },

    liste_observations: (state) => {
        return state.liste_observations
    },

    liste_adimissions: (state) => {
        return state.liste_adimissions
    },

    sfe_configs: (state) => {
        return state.sfe_configs
    },

    can_add_differential_computing: (state) => {
        return state.can_add_differential_computing;
    },

    countdown_info: (state) => {
        return state.countdown_info;
    },

    can_print_param_examen: (state) => {
        return state.can_print_param_examen;
    },
}

// mutations
const mutations = {
    // =========  PARAM EXCLU   ===========
    SET_EXCLU_CONSULTATION(state, exclu) {
        state.param_exclu_consultation = exclu
    },

    SET_EXCLU_ANALYSE(state, exclu) {
        state.param_exclu_analyse = exclu
    },

    SET_EXCLU_EXAMEN(state, exclu) {
        state.param_exclu_examen = exclu
    },

    SET_EXCLU_MEDICAMENT(state, exclu) {
        state.param_exclu_medicament = exclu
    },

    SET_EXCLU_CONSOMMABLE(state, exclu) {
        state.param_exclu_consommable = exclu
    },

    SET_EXCLU_ACTE(state, exclu) {
        state.param_exclu_acte = exclu
    },

    SET_EXCLU_ADMISSION(state, exclu) {
        state.param_exclu_admission = exclu
    },

    SET_EXCLU_CHAMBRE(state, exclu) {
        state.param_exclu_chambre = exclu
    },

    SET_EXCLU_OBSERVATION(state, exclu) {
        state.param_exclu_observation = exclu
    },

    SET_EXCLU_BILAN_SANTE(state, exclu) {
        state.param_exclu_bilan_sante = exclu
    },

    SET_EXCLU_CHIRURGIE(state, exclu) {
        state.param_exclu_chirurgie = exclu
    },
    // =====================================

    SET_PATIENT_EST_ASSURE(state, est_assure) {
        state.patient_est_assure = est_assure;
    },

    SET_PATIENT_INFO_ASSURANCE(state, info) {
        state.info_assurance = info;
    },

    SET_PRIX_PRESTATION_ASSUR(state, prix) {
        state.prix_prestation_assur = prix;
    },

    SET_LIST_CONSULTATIONS(state, list) {
        state.list_consultations = list
    },

    SET_GROUPE_ASSURS(state, groupe) {
        state.groupe_assurs = groupe
    },

    SET_GROUPE_ASSUR(state, groupe) {
        state.groupe_assur = groupe
    },

    SET_COMPAGNIE_ASSURANCES(state, compagnie) {
        state.compagnie_assurances = compagnie
    },

    SET_ASSUREUR(state, assureur) {
        state.assureur = assureur
    },

    SET_SOUSCRIPTEURS(state, souscripteurs) {
        state.souscripteurs = souscripteurs
    },

    SET_SOUSCRIPTEUR_DETAIL(state, souscripteur) {
        state.souscripteur_detail = souscripteur
    },

    SET_ALL_PARAMS_PRESTATIONS(state, params_prestation_all) {
        state.params_prestation_all = params_prestation_all
    },

    SET_PARAMS_PRESTATIONS(state, params_prestations) {
        state.params_prestations = params_prestations
    },

    SET_PARAMS_PRESTATION_NON_EXCLUS(state, params_prestation_non_exclus) {
        state.params_prestation_non_exclus = params_prestation_non_exclus
    },

    SET_PARAMS_ANALYSES(state, params_analyses) {
        state.params_analyses = params_analyses
    },

    SET_ALL_PARAMS_MEDCAT(state, params_cat_medicaments_all) {
        state.params_cat_medicaments_all = params_cat_medicaments_all
    },

    SET_PARAMS_MEDCAT_EXCLUS(state, params_cat_medicament_exclus) {
        state.params_cat_medicament_exclus = params_cat_medicament_exclus
    },

    SET_ASSURS_SANS_GROUPE(state, assurace) {
        state.assurance_sans_groupe = assurace
    },

    SET_CATEGORIE_MEDICAMENTS(state, liste) {
        state.l_categorie_medicaments = liste
    },

    SET_MEDICAMENTS_LIST(state, liste) {
        state.l_medicaments = liste
    },

    // ++++++       EXCLUSIONS LIST         ++++++
    SET_CONSULTATION_EXCLUS(state, exclu) {
        state.list_exclu_consultations = exclu
    },

    SET_ANALYSE_EXCLUS(state, exclu) {
        state.list_exclu_analyses = exclu
    },

    SET_EXAMEN_EXCLUS(state, exclu) {
        state.list_exclu_examens = exclu
    },

    SET_MEDICAMENT_EXCLUS(state, exclu) {
        state.list_exclu_medicaments = exclu
    },

    SET_CONSOMMABLE_EXCLUS(state, exclu) {
        state.list_exclu_consommables = exclu
    },

    SET_ACTE_EXCLUS(state, exclu) {
        state.list_exclu_actes = exclu
    },

    SET_ADMISSION_EXCLUS(state, exclu) {
        state.list_exclu_admissions = exclu
    },

    SET_CHAMBRE_EXCLUS(state, exclu) {
        state.list_exclu_chambres = exclu
    },

    SET_OBSERVATION_EXCLUS(state, exclu) {
        state.list_exclu_observations = exclu
    },

    SET_CHIRURGIE_EXCLUS(state, exclu) {
        state.list_exclu_chirurgies = exclu
    },

    SET_BILAN_SANTES_EXCLUS(state, exclu) {
        state.list_exclu_bilan_santes = exclu
    },
    // --------------------------------------------

    SET_USERS_EXAMENS(state,usersExamens){
        state.usersExamens = usersExamens
    },

    SET_CONFIG_INFO_CLINIQUE(state, info) {
        state.config_info_clinique = info
    },

    SET_CONFIG_INFO_DIVERS(state, info) {
        state.divers_info = info
    },

    SET_CONFIG_INFO_CURRENCY(state, info) {
        state.info_currency = info
    },

    SET_CONFIG_BON_CONSOMMABLE(state, conso) {
        state.bon_consommables = conso
    },

    SET_CONFIG_LISTE_BON_CONSOMMABLE(state, liste) {
        state.liste_all_bon_consommables = liste
    },

    SET_LISTE_CHIRURGIES(state, liste) {
        state.liste_chirurgies = liste
    },

    SET_LISTE_BILAN_SANTE(state, liste) {
        state.liste_bilan_sante = liste
    },

    SET_CONSUMABLES_OF_CONSULTATION(state, list) {
        state.consumables_of_consultation = list
    },

    SET_LISTE_CHAMBRES(state, liste) {
        state.liste_chambres = liste
    },

    SET_LISTE_OBSERVATIONS(state, liste) {
        state.liste_observations = liste
    },

    SET_LISTE_ADIMISSIONS(state, liste) {
        state.liste_adimissions = liste
    },

    SET_SFE_CONFIGS(state, info) {
        state.sfe_configs = info
    },

    SET_CAN_ADD_DIFFERENTIAL_COMPUTING(state, check_status) {
        state.can_add_differential_computing = check_status;
    },

    SET_COUNTDOWN_INFO(state, countdown) {
        state.countdown_info = countdown
    },

    SET_CAN_PRINT_PARAM_EXAMEN(state, can_print) {
        state.can_print_param_examen = can_print
    },
}

// actions
const actions = {
    checkIfPatientEstAssure({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.checkIfPatientEstAssure(patient_id).then((response) => {
                commit("SET_PATIENT_EST_ASSURE", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getPatientInfoAssurance({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPatientInfoAssurance(data).then((response) => {
                commit("SET_PATIENT_INFO_ASSURANCE", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getPrixPrestationAssur({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPrixPrestationAssur(data).then((response) => {
                commit("SET_PRIX_PRESTATION_ASSUR", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    addAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.addAssurance(data).then(
                response => {
                    dispatch('getAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAssurance({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAssurance().then(
                response => {
                    commit('SET_COMPAGNIE_ASSURANCES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteCompagnie({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteCompagnie(data).then(
                response => {
                    dispatch('getAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAssuranceById({ commit }, assurance_id) {
        return new Promise((resolve, reject) => {
            api.getAssuranceById(assurance_id).then(
                response => {
                    console.log("--> ASS ",response)
                    commit('SET_ASSUREUR', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    importerSouscripteur({ commit, dispatch }, {assurance_id, user_id, data}) {
        return new Promise((resolve, reject) => {
            api.importerSouscripteur(assurance_id, user_id, data).then(
                response => {
                    commit
                    resolve(response);
                    dispatch('listeSouscripteur', assurance_id)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    /**
     * Ajouter / Modifier un souscripteur
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
     saveSouscripteur({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveSouscripteur(data).then(
                response => {
                    dispatch('listeSouscripteur', data.assurance_id)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteSouscripteur({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteSouscripteur(data).then(
                response => {
                    dispatch('listeSouscripteur', data.assurance_id)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    listeSouscripteur({ commit }, assurance_id) {
        return new Promise((resolve, reject) => {
            api.listeSouscripteur(assurance_id).then(
                response => {
                    resolve(response)
                    commit('SET_SOUSCRIPTEURS', response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    listePrestationSouscripteur({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.listePrestationSouscripteur(data).then(
                response => {
                    resolve(response)

                    if(data.est_exclu == 1) {
                        commit('SET_PARAMS_PRESTATIONS', response)
                    } else {
                        commit('SET_PARAMS_PRESTATION_NON_EXCLUS', response)
                    }

                }, error => {
                    reject(error)
                }
            )
        })
    },

    listeAllPrestationSouscripteur({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.listeAllPrestationSouscripteur(data).then(
                response => {
                    resolve(response)
                    commit('SET_ALL_PARAMS_PRESTATIONS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getSouscripteurById({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSouscripteurById(data).then(
                response => {
                    commit('SET_SOUSCRIPTEUR_DETAIL', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updatePrestation({ dispatch }, { assurance_id, souscripteur_id, checked_exclusions }) {
        return new Promise((resolve, reject) => {
            console.log(checked_exclusions)
            api.updatePrestation(assurance_id, souscripteur_id, checked_exclusions).then(
                response => {
                    dispatch('getAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // ===========      CATEGORIE MEDICAMENT    ============
    listeMedCategorieSouscripteur({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.listeMedCategorieSouscripteur(data).then(
                response => {
                    resolve(response)
                    commit('SET_PARAMS_MEDCAT_EXCLUS', response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    listeAllMedCategorieSouscripteur({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.listeAllMedCategorieSouscripteur(data).then(
                response => {
                    resolve(response)
                    commit('SET_ALL_PARAMS_MEDCAT', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // =======  ANALYSE PARAMS  ========
    listeAnalyseSouscripteur({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.listeAnalyseSouscripteur(data).then(
                response => {
                    resolve(response)
                    commit('SET_PARAMS_ANALYSES', response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateAnalyse({ dispatch }, { assurance_id, souscripteur_id, checked_exclusions }) {
        return new Promise((resolve, reject) => {
            console.log(checked_exclusions)
            api.updateAnalyse(assurance_id, souscripteur_id, checked_exclusions).then(
                response => {
                    dispatch('listeAnalyseSouscripteur', { assurance_id: assurance_id, souscripteur_id: souscripteur_id })
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    addGroupeAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.addGroupeAssurance(data).then(
                response => {
                    dispatch('getGroupeAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getGroupeAssurance({ commit }) {
        return new Promise((resolve, reject) => {
            api.getGroupeAssurance().then(
                response => {
                    resolve(response)
                    commit('SET_GROUPE_ASSURS', response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteGroupeAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteGroupeAssurance(data).then(
                response => {
                    dispatch('getGroupeAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getGroupeAssuranceById({ commit }, groupe_id) {
        return new Promise((resolve, reject) => {
            api.getGroupeAssuranceById(groupe_id).then(
                response => {
                    resolve(response)
                    commit('SET_GROUPE_ASSUR', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAssuranceSansGroupe({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAssuranceSansGroupe().then(
                response => {
                    resolve(response)
                    commit('SET_ASSURS_SANS_GROUPE', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    configBaseActifAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            console.log(data)
            api.configBaseActifAssurance(data).then(
                response => {
                    dispatch('getGroupeAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTousTypeConsultations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getTousTypeConsultations().then(
                response => {
                    commit('SET_LIST_CONSULTATIONS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getCategorieMedicament({ commit }) {
        return new Promise((resolve, reject) => {
            api.getCategorieMedicament().then(
                response => {
                    commit('SET_CATEGORIE_MEDICAMENTS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getMedicamentList({ commit }) {
        return new Promise((resolve, reject) => {
            api.getMedicamentList().then(
                response => {
                    commit('SET_MEDICAMENTS_LIST', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setExclusion({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setExclusion(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListExclusByPrestation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListExclusByPrestation(data).then(
                response => {
                    if (data.type_prestation == 'consultation') {
                        commit('SET_CONSULTATION_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'analyse') {
                        commit('SET_ANALYSE_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'examen') {
                        commit('SET_EXAMEN_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'medicament') {
                        commit('SET_MEDICAMENT_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'consommable') {
                        commit('SET_CONSOMMABLE_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'acte') {
                        commit('SET_ACTE_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'admission') {
                        commit('SET_ADMISSION_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'chambre') {
                        commit('SET_CHAMBRE_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'observation') {
                        commit('SET_OBSERVATION_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'bilan_sante') {
                        commit('SET_BILAN_SANTES_EXCLUS', response)
                        resolve(response)
                    } else if (data.type_prestation == 'chirurgie') {
                        commit('SET_CHIRURGIE_EXCLUS', response)
                        resolve(response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    assignGroupToAssurance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.assignGroupToAssurance(data).then(
                response => {
                    dispatch('getAssurance')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getAssignedExamensToUsers({commit},data){
        return new Promise((resolve,reject) => {
            api.getAssignedExamensToUsers(data).then(
                response => {
                    commit('SET_USERS_EXAMENS',response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
    assignExamensToUsers({dispatch},{user_id,data}){
        return new Promise((resolve,reject) => {
            api.assignExamensToUsers(user_id,data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConfigInfoClinique({commit}, data_type){
        return new Promise((resolve,reject) => {
            api.getConfigInfoClinique(data_type).then(
                response => {
                    if (data_type == 'info_clinique') {
                        commit('SET_CONFIG_INFO_CLINIQUE', response)
                    } else if (data_type == 'divers_info') {
                        commit('SET_CONFIG_INFO_DIVERS', response)
                    } else if (data_type == 'bon_consommable') {
                        commit('SET_CONFIG_BON_CONSOMMABLE', response)
                    } else if (data_type == 'info_sfe') {
                        commit('SET_SFE_CONFIGS', response)
                    } else if (data_type == 'currency') {
                        commit('SET_CONFIG_INFO_CURRENCY', response)
                    }
                    
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeAllBonConsommable({commit}){
        return new Promise((resolve,reject) => {
            api.getListeAllBonConsommable().then(
                response => {
                    commit('SET_CONFIG_LISTE_BON_CONSOMMABLE', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveConfigInfoClinique({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveConfigInfoClinique(data).then(
                response => {
                    dispatch('getConfigInfoClinique', 'info_clinique')
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    /**
     * Associe les types de consultations à un consommeble de bon de consultation
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    saveConsommableBonVisibilite({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveConsommableBonVisibilite(data).then(
                response => {
                    dispatch('getConfigInfoClinique', 'bon_consommable')
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveChirurgie({dispatch}, data) {
        return new Promise((resolve,reject) => {
            api.saveChirurgie(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveKChirurgie({dispatch}, data) {
        return new Promise((resolve,reject) => {
            api.saveKChirurgie(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeChirurgies({commit}){
        return new Promise((resolve,reject) => {
            api.getListeChirurgies().then(
                response => {
                    commit('SET_LISTE_CHIRURGIES', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    deleteItem({dispatch}, data) {
        return new Promise((resolve,reject) => {
            api.deleteItem(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    // ++++++++++   BILAN DE SANTE    ++++++++++++
    saveBilanSante({dispatch}, data) {
        return new Promise((resolve,reject) => {
            api.saveBilanSante(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeBilanSante({commit}){
        return new Promise((resolve,reject) => {
            api.getListeBilanSante().then(
                response => {
                    commit('SET_LISTE_BILAN_SANTE', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    deleteBilanSante({dispatch}, data) {
        return new Promise((resolve,reject) => {
            api.deleteBilanSante(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getConsumableOfConsultation({commit}, data){
        return new Promise((resolve,reject) => {
            api.getConsumableOfConsultation(data).then(
                response => {
                    commit('SET_CONSUMABLES_OF_CONSULTATION', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    saveConsumableOfConsultation({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveConsumableOfConsultation(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    deleteConsumableOfConsultation({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.deleteConsumableOfConsultation(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    /**
     * Liste des types d'admission de type chambre ou observation
     * @param {*} param0 
     * @param {*} data_type chambre | observation 
     * @returns 
     */
    getListeTypeAdmission({ commit }, data_type) {
        return new Promise((resolve, reject) => {
            api.getListeTypeAdmission(data_type).then(
                response => {
                    if(data_type == 'chambre') {
                        commit('SET_LISTE_CHAMBRES', response)
                    } else if(data_type == 'observation') {
                        commit('SET_LISTE_OBSERVATIONS', response)
                    } else if(data_type == 'admission') {
                        commit('SET_LISTE_ADIMISSIONS', response)
                    }
                    resolve(response)

                }, error => {
                    reject(error)
                }
            )
        })
    },

    storeAdmission({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.storeAdmission(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    deleteAdmissionByType({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.deleteAdmissionByType(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    importAnalyse({ dispatch }, { data }) {
        return new Promise((resolve, reject) => {
            api.importAnalyse(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    importPrestation({ dispatch }, { data }) {
        return new Promise((resolve, reject) => {
            api.importPrestation(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDifferentialComputing({ commit }) {
        return new Promise((resolve, reject) => {
            api.getDifferentialComputing().then(
                response => {
                    commit('SET_CAN_ADD_DIFFERENTIAL_COMPUTING', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getCountDown({ commit }) {
        return new Promise((resolve, reject) => {
            api.getCountDown().then((response) => {
                commit("SET_COUNTDOWN_INFO", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    storeConfigHistorique({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.storeConfigHistorique(data).then(
                response => {
                    dispatch
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}